// Pure time-bucketing for the Employees / My Tasks page (increment 6). Sorts a person's
// tasks into Overdue / This week / Next week / Later / Recently completed. `now` is injected
// so it's deterministic in tests. Week ends on Sunday; "recently completed" = last 14 days.
function isoLocal(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export const BUCKETS = ["overdue", "thisWeek", "nextWeek", "later", "recentlyCompleted"];
export const BUCKET_LABEL = {
  overdue: "Overdue", thisWeek: "This week", nextWeek: "Next week",
  later: "Later", recentlyCompleted: "Recently completed",
};

export function bucketTasks(tasks, now = Date.now()) {
  const today = new Date(now); today.setHours(0, 0, 0, 0);
  const todayStr = isoLocal(today);
  const eow = new Date(today); eow.setDate(today.getDate() + ((7 - today.getDay()) % 7)); // coming Sunday
  const eowStr = isoLocal(eow);
  const eonw = new Date(eow); eonw.setDate(eow.getDate() + 7);
  const eonwStr = isoLocal(eonw);
  const cutoff = new Date(today); cutoff.setDate(today.getDate() - 14);
  const cutoffStr = isoLocal(cutoff);

  const b = { overdue: [], thisWeek: [], nextWeek: [], later: [], recentlyCompleted: [] };
  for (const t of tasks || []) {
    if (t.status === "Completed") {
      const c = (t.completedAt || "").slice(0, 10);
      if (c && c >= cutoffStr) b.recentlyCompleted.push(t);
      continue;
    }
    const due = (t.dueDate || "").slice(0, 10);
    if (!due) b.later.push(t);
    else if (due < todayStr) b.overdue.push(t);
    else if (due <= eowStr) b.thisWeek.push(t);
    else if (due <= eonwStr) b.nextWeek.push(t);
    else b.later.push(t);
  }
  const byDue = (a, z) => ((a.dueDate || "") < (z.dueDate || "") ? -1 : 1);
  b.overdue.sort(byDue); b.thisWeek.sort(byDue); b.nextWeek.sort(byDue); b.later.sort(byDue);
  b.recentlyCompleted.sort((a, z) => ((a.completedAt || "") > (z.completedAt || "") ? -1 : 1)); // newest first
  return b;
}
